import { BootstrapVue, BTable } from 'bootstrap-vue';
import { far } from '@fortawesome/free-regular-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome';
import { library } from '@fortawesome/fontawesome-svg-core';

import App from './App.vue';
import Notifications from 'vue-notification';
import router from './router';
import Vue from 'vue';
import VueMask from 'v-mask';

import 'bootstrap/dist/css/bootstrap.css';
import 'bootstrap-vue/dist/bootstrap-vue.css';
import './registerServiceWorker';
import axios from 'axios';

library.add(far);

window.axios = require('axios');
//window.axios.defaults.baseURL = 'http://192.168.0.105:3000';
window.axios.defaults.headers.common['Access-Control-Allow-Origin'] = '*';

const actions = {
  clearAll(state) {
    if (state.id) {
      state.id = null;
    }

    if (state.idd) {
      state.idd = null;
    }

    state.lType = null;
    state.password = null;
    state.token = null;
    state.user = null;
    state.userType = "all";
  },
  clearLaudos() { 
    store.laudos = [];
  },
  setLaudos(lst) { 
    store.laudos = lst;
  },
  setFilial(state, filial) {
    state.idd = filial;
  },
  setLoginType(state, tp) {
    state.lType = tp;
  },
  setPassword(state, pass) {
    state.password = pass;
  },
  setToken(state, token) {
    state.token = token;
  },
  setUser(state, user) {
    state.user = user;
  },
  setUserID(state, id) {
    state.id = id;
  },
  setUserType(state, userType) {
    state.userType = userType;
  },
  isLoggedIn(state) {
    return !!state.token;
  },
};

const store = Vue.observable({
  state: {
    id: null,
    idd: null,
    lType: null,
    password: null,
    token: null,
    user: null,
    userType: 'all',
  },
  laudos: []
});

Vue.prototype.$actions = actions;
Vue.prototype.$store = store;

Vue.component('font-awesome-icon', FontAwesomeIcon);
Vue.use(BootstrapVue);
Vue.use(Notifications);
Vue.use(VueMask);

Vue.config.productionTip = false;

async function getSettings() {
  try {
    const response = await fetch('assets/config.json');

    if (response.ok) {
      const json = await response.json();
      
      window.axios.defaults.headers.common['Authorization'] = json.api_key;
      window.axios.defaults.baseURL = json.api_url;

      document.documentElement.style.setProperty("--primary-color", json.primary_color);
      document.documentElement.style.setProperty("--primary-color-shadow", json.primary_color_shadow);
      document.documentElement.style.setProperty("--secondary-color", json.secondary_color);
      document.title = json.laboratory;

      Vue.prototype.$signedOnly = json.signed_only;
      Vue.prototype.$downloadUnsigned = json.download_unsigned;
      Vue.prototype.$minDate = json.min_date;
      Vue.prototype.$laboratory = json.laboratory;
      Vue.prototype.$changePassword = json.change_password;
    }
  } catch (error) {
    console.error(error);
  }
}

Vue.prototype.$version = "v2026.05.28";

getSettings();

new Vue({
  router,
  render: function (h) { return h(App); }
}).$mount('#app');